import { ProductsCategory, productsKeyConstants } from '../../../../../config';

export const categoryBasedContent = {
  [ProductsCategory.RELIEF_FACTOR]: {
    productKey: productsKeyConstants.RF_RELIEF_FACTOR_QS_NEC,
    tags: {
      overview: {
        key: 'overview',
        text: 'Overview',
        href: '#overview',
      },
      howitworks: {
        key: 'howitworks',
        text: 'How it Works',
        href: '#howitworks',
      },
      ingredients: {
        key: 'ingredients',
        text: 'Ingredients',
        href: '#ingredients',
      },
      testimonials: {
        key: 'testimonials',
        text: 'Testimonials',
        href: '#testimonials',
      },
      faq: {
        key: 'faq',
        text: 'FAQs',
        href: '#faq',
      },
    },
  },
  [ProductsCategory.THINK_FACTOR]: {
    productKey: productsKeyConstants.RF_THINK_FACTOR,
    tags: {
      overview: {
        key: 'overview',
        text: 'Overview',
        href: '#overview',
      },
      howitworks: {
        key: 'howitworks',
        text: 'How it Works',
        href: '#howitworks',
      },
      ingredients: {
        key: 'ingredients',
        text: 'Ingredients',
        href: '#ingredients',
      },
      usecases: {
        key: 'usecases',
        text: 'Lifestyle',
        href: '#usecases',
      },
      price: {
        key: 'price',
        text: 'Value',
        href: '#price',
      },
    },
  },
  [ProductsCategory.ZEN_FACTOR]: {
    productKey: productsKeyConstants.RF_ZEN_FACTOR,
    tags: {
      overview: {
        key: 'overview',
        text: 'Overview',
        href: '#overview',
      },
      howitworks: {
        key: 'howitworks',
        text: 'How it Works',
        href: '#howitworks',
      },
      ingredients: {
        key: 'ingredients',
        text: 'Ingredients',
        href: '#ingredients',
      },
      testimonials: {
        key: 'testimonials',
        text: 'Testimonials',
        href: '#testimonials',
      },
      faq: {
        key: 'faq',
        text: 'FAQs',
        href: '#faq',
      },
    },
  },
  [ProductsCategory.GO_FACTOR]: {
    productKey: productsKeyConstants.RF_GO_FACTOR,
    tags: {
      overview: {
        key: 'overview',
        text: 'Overview',
        href: '#overview',
      },
      howitworks: {
        key: 'howitworks',
        text: 'How it Works',
        href: '#howitworks',
      },
      ingredients: {
        key: 'ingredients',
        text: 'Ingredients',
        href: '#ingredients',
      },
      testimonials: {
        key: 'testimonials',
        text: 'Testimonials',
        href: '#testimonials',
      },
      faq: {
        key: 'faq',
        text: 'FAQs',
        href: '#faq',
      },
    },
  },
  [ProductsCategory.Z_FACTOR]: {
    productKey: productsKeyConstants.RF_Z_FACTOR,
    tags: {
      overview: {
        key: 'overview',
        text: 'Overview',
        href: '#overview',
      },
      howitworks: {
        key: 'howitworks',
        text: 'How it Works',
        href: '#howitworks',
      },
      ingredients: {
        key: 'ingredients',
        text: 'Ingredients',
        href: '#ingredients',
      },
      testimonials: {
        key: 'testimonials',
        text: 'Testimonials',
        href: '#testimonials',
      },
      faq: {
        key: 'faq',
        text: 'FAQs',
        href: '#faq',
      },
    },
  },
  [ProductsCategory.ANTIOXIDANTS]: {
    productKey: productsKeyConstants.DE_ANTIOXIDANTS,
    tags: {
      overview: {
        key: 'overview',
        text: 'Overview',
        href: '#overview',
      },
      howitworks: {
        key: 'howitworks',
        text: 'How it Works',
        href: '#howitworks',
      },
      ingredients: {
        key: 'ingredients',
        text: 'Ingredients',
        href: '#ingredients',
      },
      usecases: {
        key: 'usecases',
        text: 'Lifestyle',
        href: '#usecases',
      },
      price: {
        key: 'price',
        text: 'Value',
        href: '#price',
      },
    },
  },
  [ProductsCategory.FULL_SPECTRUM_E]: {
    productKey: productsKeyConstants.RF_FULL_SPECTRUM_E,
    tags: {
      overview: {
        key: 'overview',
        text: 'Overview',
        href: '#overview',
      },
      howitworks: {
        key: 'howitworks',
        text: 'How it Works',
        href: '#howitworks',
      },
      ingredients: {
        key: 'ingredients',
        text: 'Ingredients',
        href: '#ingredients',
      },
      usecases: {
        key: 'usecases',
        text: 'Lifestyle',
        href: '#usecases',
      },
      price: {
        key: 'price',
        text: 'Value',
        href: '#price',
      },
    },
  },
  [ProductsCategory.IMMUNE_FACTOR]: {
    productKey: productsKeyConstants.RF_IMMUNE_FACTOR,
    tags: {
      overview: {
        key: 'overview',
        text: 'Overview',
        href: '#overview',
      },
      howitworks: {
        key: 'howitworks',
        text: 'How it Works',
        href: '#howitworks',
      },
      ingredients: {
        key: 'ingredients',
        text: 'Ingredients',
        href: '#ingredients',
      },
      usecases: {
        key: 'usecases',
        text: 'Lifestyle',
        href: '#usecases',
      },
      price: {
        key: 'price',
        text: 'Value',
        href: '#price',
      },
    },
  },
  [ProductsCategory.N_ACETYL_CYSTEINE]: {
    productKey: productsKeyConstants.RF_N_ACETYL_CYSTEINE,
    tags: {
      overview: {
        key: 'overview',
        text: 'Overview',
        href: '#overview',
      },
      howitworks: {
        key: 'howitworks',
        text: 'How it Works',
        href: '#howitworks',
      },
      ingredients: {
        key: 'ingredients',
        text: 'Ingredients',
        href: '#ingredients',
      },
      usecases: {
        key: 'usecases',
        text: 'Lifestyle',
        href: '#usecases',
      },
      price: {
        key: 'price',
        text: 'Value',
        href: '#price',
      },
    },
  },
  [ProductsCategory.RED_YEAST_RICE]: {
    productKey: productsKeyConstants.RF_RED_YEAST_RICE,
    tags: {
      overview: {
        key: 'overview',
        text: 'Overview',
        href: '#overview',
      },
      howitworks: {
        key: 'howitworks',
        text: 'How it Works',
        href: '#howitworks',
      },
      ingredients: {
        key: 'ingredients',
        text: 'Ingredients',
        href: '#ingredients',
      },
      usecases: {
        key: 'usecases',
        text: 'Lifestyle',
        href: '#usecases',
      },
      price: {
        key: 'price',
        text: 'Value',
        href: '#price',
      },
    },
  },
  [ProductsCategory.VITAMIN_B_COMPLEX]: {
    productKey: productsKeyConstants.RF_VITAMIN_B_COMPLEX,
    tags: {
      overview: {
        key: 'overview',
        text: 'Overview',
        href: '#overview',
      },
      howitworks: {
        key: 'howitworks',
        text: 'How it Works',
        href: '#howitworks',
      },
      ingredients: {
        key: 'ingredients',
        text: 'Ingredients',
        href: '#ingredients',
      },
      usecases: {
        key: 'usecases',
        text: 'Lifestyle',
        href: '#usecases',
      },
      price: {
        key: 'price',
        text: 'Value',
        href: '#price',
      },
    },
  },
  [ProductsCategory.VESSEL_PROTECTION]: {
    productKey: productsKeyConstants.RF_VESSEL_PROTECTION,
    tags: {
      overview: {
        key: 'overview',
        text: 'Overview',
        href: '#overview',
      },
      howitworks: {
        key: 'howitworks',
        text: 'How it Works',
        href: '#howitworks',
      },
      ingredients: {
        key: 'ingredients',
        text: 'Ingredients',
        href: '#ingredients',
      },
      usecases: {
        key: 'usecases',
        text: 'Lifestyle',
        href: '#usecases',
      },
      price: {
        key: 'price',
        text: 'Value',
        href: '#price',
      },
    },
  },
  [ProductsCategory.BERBERINE]: {
    productKey: productsKeyConstants.RF_BERBERINE,
    tags: {
      overview: {
        key: 'overview',
        text: 'Overview',
        href: '#overview',
      },
      howitworks: {
        key: 'howitworks',
        text: 'How it Works',
        href: '#howitworks',
      },
      ingredients: {
        key: 'ingredients',
        text: 'Ingredients',
        href: '#ingredients',
      },
      usecases: {
        key: 'usecases',
        text: 'Lifestyle',
        href: '#usecases',
      },
      price: {
        key: 'price',
        text: 'Value',
        href: '#price',
      },
    },
  },
  [ProductsCategory.VITAMIN_D_K2]: {
    productKey: productsKeyConstants.RF_VITAMIN_D_K2,
    tags: {
      overview: {
        key: 'overview',
        text: 'Overview',
        href: '#overview',
      },
      howitworks: {
        key: 'howitworks',
        text: 'How it Works',
        href: '#howitworks',
      },
      ingredients: {
        key: 'ingredients',
        text: 'Ingredients',
        href: '#ingredients',
      },
      usecases: {
        key: 'usecases',
        text: 'Lifestyle',
        href: '#usecases',
      },
      price: {
        key: 'price',
        text: 'Value',
        href: '#price',
      },
    },
  },
  [ProductsCategory.VITAMIN_D_K5]: {
    productKey: productsKeyConstants.RF_VITAMIN_D_K5,
    tags: {
      overview: {
        key: 'overview',
        text: 'Overview',
        href: '#overview',
      },
      howitworks: {
        key: 'howitworks',
        text: 'How it Works',
        href: '#howitworks',
      },
      ingredients: {
        key: 'ingredients',
        text: 'Ingredients',
        href: '#ingredients',
      },
      usecases: {
        key: 'usecases',
        text: 'Lifestyle',
        href: '#usecases',
      },
      price: {
        key: 'price',
        text: 'Value',
        href: '#price',
      },
    },
  },
};
